import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';
import { Button, Menu } from 'antd';
import { Dispatch, FC, SetStateAction } from 'react';
import classNames from 'classnames';

import { deleteFilter, getFilters } from 'features/primaryMarket/actions';

import { DropDownComponent } from 'componets/common';

import { ReactComponent as BinIcon } from 'assets/icons/bin.svg';

import { FieldData, IFilterValues, ISavedFilter } from 'models';

import styles from './index.module.scss';
import { selectGlobals } from '../../../../../selectors';

export const PrimaryMarketSavedFilters: FC<{
	onSetFields: (changedFields: FieldData[], allFields?: FieldData[]) => void;
	setActiveFilter: Dispatch<SetStateAction<ISavedFilter>>;
	activeFilter: ISavedFilter;
	onClose?: () => void;
}> = ({ onSetFields, activeFilter, setActiveFilter, onClose }) => {
	const savedFilters = useAppSelector((state) => state.primaryMarket.filters);
	const globals = useAppSelector(selectGlobals);

	const { mySavedFiltersText } = useTranslate(['mySavedFiltersText']);

	const dispatch = useAppDispatch();

	const onClickFilter = (item: ISavedFilter) => {
		setActiveFilter(item);

		const { criteria } = item;

		const data: IFilterValues = {
			country: criteria.countryIds,
			excludeMyInvestment: criteria.hideInvested ? '1' : '',
			'interestRate[to]': criteria.maxInterestRate,
			'interestRate[from]': criteria.minInterestRate,
			riskLvl: criteria.riskLvl,
			type: globals.loanTypes
				.filter((item) => criteria.loanTermId?.indexOf(item.id) !== -1)
				.map((item) => item.type),
		};

		const fields = Object.keys(data).map((item) => ({
			name: item,
			value: data[item as keyof IFilterValues],
		}));

		onSetFields(fields);
	};

	const onDeleteFilter = (id: string) => {
		dispatch(deleteFilter(id)).then(() => {
			dispatch(getFilters());
		});
	};

	if (savedFilters.length === 0) return <></>;

	return (
		<div className={styles.select}>
			<DropDownComponent
				className="white-btn"
				overlayClassName={styles.wrapper}
				dropdownRender={() => (
					<Menu className={styles.savedFilters}>
						{savedFilters.map((item) => {
							return (
								<Menu.Item
									className={classNames(styles.item, {
										[styles.active]: item.id === activeFilter?.id,
									})}
									key={item.id}
								>
									<span
										className={styles.menuTitle}
										role="button"
										onClick={() => {
											onClickFilter(item);
											if (onClose) {
												onClose();
											}
										}}
									>
										{item.title}
									</span>
									<Button onClick={() => onDeleteFilter(item.id)} type="link" icon={<BinIcon />} />
								</Menu.Item>
							);
						})}
					</Menu>
				)}
				label={activeFilter?.id ? activeFilter.title : mySavedFiltersText}
			/>
		</div>
	);
};
